import { FiChevronDown } from "react-icons/fi";
import { BaseAccordionItem } from "../../../../../components/accordion/item/base";
import { Checkbox } from "../../../../../components/checkbox";
import { SelectOption } from "../../../../../components/select/select";

interface JobFilterItemProps {
  type: string;
  title: string;
  count: number;
  items: SelectOption[];
  onItemClick: (item: SelectOption) => void;
  selectedItems: Record<string, boolean>;
}

export const JobFilterItem = (props: JobFilterItemProps) => {
  return (
    <BaseAccordionItem
      value={props.type}
      header={
        <div className="flex items-center gap-x-2 text-blue-500">
          <span>{props.title}</span>
          {props.count > 0 ? (
            <div className="bg-service-highlight flex h-5 items-center rounded-xl px-3 text-sm text-white">
              {props.count}
            </div>
          ) : (
            <div className="h-5" />
          )}
        </div>
      }
      trigger={
        <span className="text-base font-medium">
          <FiChevronDown />
        </span>
      }
      itemClass="border-t max-h-[250px] overflow-hidden first-of-type:border-t-0 first-of-type:mt-0 first-of-type:pt-0 pt-6 mt-5 flex flex-col border-dublin-gray text-charcoal"
      headerClass="w-full"
      triggerClass="flex justify-between  items-center w-full text-base font-medium"
      triggerButtonClass="transition-transform"
      triggerButtonOpenClass="rotateOnOpen"
      contentClass="mt-4 styled-scroll overflow-y-auto"
    >
      <ul className="flex flex-col gap-y-3">
        {props.items.length === 0 ? (
          <div>
            <p className="text-light-elephant select-none py-2 text-center text-base font-medium">
              No options available
            </p>
          </div>
        ) : null}
        {props.items.map((item) => {
          return (
            <label key={item.key} className="flex items-center gap-x-2">
              <Checkbox
                checked={props.selectedItems[item.value]}
                onChange={() => props.onItemClick(item)}
              />
              <span className="text-base">{item.label}</span>
            </label>
          );
        })}
      </ul>
    </BaseAccordionItem>
  );
};
